import React from "react";
import { creditCardData } from "utils/constants";

import CreditCarousel from "./Carousels/credit-carousel";
import FadeIn from "./common/FadeInEffect";

function NewToCredit({ deviceType }) {
  return (
    <div className="flex flex-col lg:justify-start items-center text-center px-6">
      <FadeIn>
        <h2 className="text-size-6 lg:text-6xl 3xl:text-7xl 4xl:text-size-11 4xl:leading-124 4xl:mb-4 mb-2 font-normal font-ppNeue">
          New to credit?
        </h2>
      </FadeIn>

      <FadeIn>
        <p className="text-base lg:w-[776px] lg:text-xl 3xl:text-2xl 4xl:text-4xl 4xl:leading-10 lg:mb-5 md:mb-6 mb-0 4xl:mb-12 font-normal">
          To help you make sense of the essentials, we&apos;ve answered the top
          questions about how credit cards work
        </p>
      </FadeIn>
      <CreditCarousel deviceType={deviceType} streams={creditCardData} />
    </div>
  );
}

export default NewToCredit;
